module.exports = __webpack_public_path__ + "media/dualkey.9f001e4d.svg";